import { useDispatch, useSelector } from "react-redux";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { ISupportChatButtonProps } from "@tenant/self-serve";

import {
  endChatSession,
  toggleChatWindow,
} from "../../store/supportChatReducer";
import {
  getHasActiveChatSession,
  getIsMinimized,
} from "../../store/supportChatSelectors";

export const useSupportChatButton = (props: ISupportChatButtonProps = {}) => {
  const { onClick, preventToggleClose = false } = props;
  const dispatch = useDispatch();
  const isMinimized = useSelector(getIsMinimized);
  const hasActiveChatSession = useSelector(getHasActiveChatSession);
  const { t } = useI18nContext();

  const closeChat = () => {
    dispatch(endChatSession());
  };

  const toggleChat = () => {
    onClick?.();

    if (preventToggleClose) {
      if (isMinimized) {
        dispatch(toggleChatWindow());
      }
    } else {
      dispatch(toggleChatWindow());
    }
  };

  return {
    context: { isMinimized, hasActiveChatSession },
    copy: {
      toggleBtnLabel: t("core-self-serve.supportChat.toggleBtn"),
    },
    handlers: { closeChat, toggleChat },
  };
};

export type ISupportChatButtonData = ReturnType<typeof useSupportChatButton>;
